import { render, staticRenderFns } from "./materialCard.vue?vue&type=template&id=11428eec&scoped=true"
import script from "./materialCard.vue?vue&type=script&lang=js"
export * from "./materialCard.vue?vue&type=script&lang=js"
import style0 from "./materialCard.vue?vue&type=style&index=0&id=11428eec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11428eec",
  null
  
)

export default component.exports